import Icon from '../components/Icon.vue'

Icon.register({
  'temperature-low': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 0c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zM416 128c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM256 112v166.5c19.7 24.6 32 55.5 32 89.5 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-34 12.3-64.8 32-89.5v-166.5c0-61.9 50.1-112 112-112s112 50.1 112 112zM144 448c44.1 0 80-35.9 80-80 0-25.5-12.2-49-32-63.8v-192.2c0-26.5-21.5-48-48-48s-48 21.5-48 48v192.2c-19.8 14.9-32 38.3-32 63.8 0 44.1 35.9 80 80 80zM160 322.9c18.6 6.6 32 24.2 32 45.1 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.5 32-45.1v-18.9c0-8.8 7.2-16 16-16s16 7.2 16 16v18.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/temperature-low.js
// module id = 1989
// module chunks = 0